module.exports = __webpack_public_path__ + "static/media/b-sci-major-27_LR.60e27543.jpg";